import { ItemsPerPage } from '@billy/design-system'

import { useFetchSalesDocuments } from '@features/invoices/hooks/useFetchSalesDocuments'

export const useIsSalesReportDataEmpty = (): boolean => {
  const { documents: invoices, isFetched: isInvoicesFetched } = useFetchSalesDocuments({
    documentsListType: 'invoices',
    page: 1,
    pageSize: 1 as ItemsPerPage,
  })

  return isInvoicesFetched && invoices?.length === 0
}
